import momentTz from "moment-timezone";

export default (user) => {
  return user?.time_zone || momentTz.tz.guess()
}
